import { render } from "./BrandPortfolioSpendCell.vue?vue&type=template&id=0c96c4ac&scoped=true"
import script from "./BrandPortfolioSpendCell.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioSpendCell.vue?vue&type=script&lang=js"

import "./BrandPortfolioSpendCell.vue?vue&type=style&index=0&id=0c96c4ac&scoped=true&lang=scss"
import "./BrandPortfolioSpendCell.vue?vue&type=style&index=1&id=0c96c4ac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c96c4ac"]])

export default __exports__